import { render } from "./Nl2br.vue?vue&type=template&id=24d0dc16"
import script from "./Nl2br.vue?vue&type=script&lang=js"
export * from "./Nl2br.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__